import {
  INotification,
  INotificationType,
} from "shared/components/organisms/AppNotification/@types";
import { ActivitieDataEndingNotification } from "shared/components/organisms/AppNotification/components/molecules/ActivitieDateEndingNotification";
import { CampaignNotification } from "shared/components/organisms/AppNotification/components/molecules/CampaignNotification";
import { ClaimRewardNotification } from "shared/components/organisms/AppNotification/components/molecules/ClaimRewardNotification";
import { ClimbedPodiumNotification } from "shared/components/organisms/AppNotification/components/molecules/ClimbedPodiumNotification";
import { DefaultNotification } from "shared/components/organisms/AppNotification/components/molecules/DefaultNotification";
import { LevelUpNotification } from "shared/components/organisms/AppNotification/components/molecules/LevelUpNotification";
import { LosePodiumNotification } from "shared/components/organisms/AppNotification/components/molecules/LosePodiumNotification";
import { PrivateNotification } from "shared/components/organisms/AppNotification/components/molecules/PrivateNotification";
import { ReactionNotification } from "shared/components/organisms/AppNotification/components/molecules/ReactionNotification";
import { TicketCreatedNotification } from "shared/components/organisms/AppNotification/components/molecules/TicketCreatedNotification";

import { CommentOnTicketNotification } from "../../components/molecules/CommentOnTicketNotification";

type INotificationComponentsMap = {
  [key in INotificationType]: ({}: {
    notification: INotification<any>;
  }) => JSX.Element;
};

const NotificationComponents: INotificationComponentsMap = {
  mention: DefaultNotification,
  public_post_comment: DefaultNotification,
  public_lesson_comment: DefaultNotification,
  reaction: ReactionNotification,
  private_lesson_comment: PrivateNotification,
  level_update: LevelUpNotification,
  claim_message: ClaimRewardNotification,
  ranking_up: ClimbedPodiumNotification,
  ranking_down: LosePodiumNotification,
  campaign: CampaignNotification,
  lesson_finishes_in_7_days: ActivitieDataEndingNotification,
  lesson_finishes_in_3_days: ActivitieDataEndingNotification,
  lesson_finishes_today: ActivitieDataEndingNotification,
  feed_post_comment: DefaultNotification,
  ticket_created: TicketCreatedNotification,
  ticket_new_message: CommentOnTicketNotification,
};

export const getNotificationComponent = (
  notification: INotification<any>,
): JSX.Element => {
  const NotificationComponent =
    NotificationComponents?.[notification?.type] ?? DefaultNotification;

  return <NotificationComponent notification={notification} />;
};
